"use client";

import { useContext } from "react";

import {
  NavigationStateContext,
  type NavigationStateState,
} from "./NavigationStateContext";

export const useNavigationState = (): NavigationStateState => {
  const context = useContext(NavigationStateContext);
  if (context === undefined) {
    throw new Error(
      "useNavigationState must be used within NavigationStateProvider",
    );
  }

  return context;
};

export const useMaybeNavigationState = (): NavigationStateState | undefined =>
  useContext(NavigationStateContext);
